export { EmptyState, emptyStateVariants, type EmptyStateProps } from './EmptyState'
